import styled from 'styled-components';
import { InteriorSelectStyled } from '../InteriorSelectStyled';
import { rem } from 'polished';

export const InteriorSelectStyledOV = styled(InteriorSelectStyled)`
    .react-multiple-carousel__arrow {
        border-width: ${rem(2)};
    }
    .interior {
        border-color: ${({ theme }) => theme.colors.grey18};

        &.isSelected,
        &:hover,
        &:focus-visible {
            border-color: ${({ theme }) => theme.colors.black};
            .inner {
                border-color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .interiorTitle {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        .icon {
            background: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
            .selected {
                background: ${({ theme }) => theme.colors.black};
                width: ${rem(8)};
                height: ${rem(8)};
                top: ${rem(7)};
                left: ${rem(7)};
            }
        }
    }

    .interiorPrice {
        color: ${({ theme }) => theme.colors.grey27};
    }

    .isSelected {
        background: ${({ theme }) => theme.colors.grey10};
    }
`;
